import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import ExecutionFormHandler from './_form/ExecutionFormHandler'
import PageContent from './PageContent'
import ServiceOrderLoader from './_load/ServiceOrderLoader'
import { PermissionChecker } from '../../session'
import ConfigsLoader from '../../../containers/configs/_load/ConfigsLoader'
import { useIsPermalinkPage } from '../../../utils/session/permalinkToken'

const ExecutionPage = ({ id }) => {
  return (
    <AbsolutePageTemplate>
      <PublicWrapper>
        <ServiceOrderLoader id={id}>
          <ExecutionFormHandler>
            <PageContent />
          </ExecutionFormHandler>
        </ServiceOrderLoader>
      </PublicWrapper>
    </AbsolutePageTemplate>
  )
}

const PublicWrapper = ({ children }) => {
  const isPublic = useIsPermalinkPage()
  if (isPublic) return children
  return (
    <PermissionChecker permission="canExecuteFromWeb">
      <ConfigsLoader>{children}</ConfigsLoader>
    </PermissionChecker>
  )
}

export default ExecutionPage
